import ProjectInvestmentsPage from "./ProjectInvestmentsPage"

export default ProjectInvestmentsPage
